import { jsx } from 'react/jsx-runtime';

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var angleDown = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("g", {
    children: /*#__PURE__*/jsx("path", {
      d: "M17 9.17a1 1 0 0 0-1.41 0L12 12.71L8.46 9.17a1 1 0 0 0-1.41 0a1 1 0 0 0 0 1.42l4.24 4.24a1 1 0 0 0 1.42 0L17 10.59a1 1 0 0 0 0-1.42z"
    })
  })
});

var angleUp = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("g", {
    children: /*#__PURE__*/jsx("path", {
      d: "M17 13.41l-4.29-4.24a1 1 0 0 0-1.42 0l-4.24 4.24a1 1 0 0 0 0 1.42a1 1 0 0 0 1.41 0L12 11.29l3.54 3.54a1 1 0 0 0 .7.29a1 1 0 0 0 .71-.29a1 1 0 0 0 .05-1.42z"
    })
  })
});

var close = /*#__PURE__*/jsx("svg", {
  viewBox: "0 0 24 24",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  role: "img",
  children: /*#__PURE__*/jsx("path", {
    d: "M7.05025 5.63603L11.9991 10.5851L16.9497 5.63603C17.3403 5.24551 17.9734 5.24551 18.364 5.63603C18.7545 6.02656 18.7545 6.65972 18.364 7.05025L13.4141 11.9991L18.364 16.9497C18.7545 17.3403 18.7545 17.9734 18.364 18.364C17.9734 18.7545 17.3403 18.7545 16.9497 18.364L11.9991 13.4141L7.05025 18.364C6.65972 18.7545 6.02656 18.7545 5.63603 18.364C5.24551 17.9734 5.24551 17.3403 5.63603 16.9497L10.5851 11.9991L5.63603 7.05025C5.24551 6.65972 5.24551 6.02656 5.63603 5.63603C6.02656 5.24551 6.65972 5.24551 7.05025 5.63603Z"
  })
});

export { angleDown as a, angleUp as b, close as c };
